
import LeftNav from '@/components/LeftNav.vue'
import ApLink from '@/components/APLink.vue'
import { GetData } from '@/service'
export default {
  app: 'home',
  components: {
    LeftNav,
    ApLink
  },
  data() {
    return {
      navItems: [],
      contactUsUrl: '',
      facebookUrl: '',
      twitterUrl: '',
      youtubeUrl: '',
      linkedinUrl: '',
      legalnoticeUrl: '',
      privacypolicyUrl: '',
      cookieNoticeUrl: '',
      customerSupportUrl: ''
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    revalidationStatus() {
      return this.$store.state.revalidationStatus
    },
    isMembraneCustomer() {
      return this.$store.state.shipTos.some((shipTo) => {
        const legalEntityCode = shipTo && shipTo.legalEntityCode ? shipTo.legalEntityCode.trim() : ''
        const shipToType = shipTo && shipTo.shipToType ? shipTo.shipToType.trim() : ''
        return legalEntityCode === 'US10' && shipToType === 'EQ'
      })
    }
  },
  async mounted() {
    window.apci.init([
      {
        countries: ['GB'],
        salesOrgs: ['GB46'],
        disable: {
          favIcon: false, pageTitle: false, logo: false, myText: false, myCompanyWebsite: false, contactUs: true, customerSuppport: false, footer: false, copyright: false, stylesheet: false
        },
        actions: []
      },
      {
        countries: ['GB'],
        salesOrgs: ['GB47'],
        disable: {
          favIcon: false, pageTitle: false, logo: false, myText: false, myCompanyWebsite: false, contactUs: true, customerSuppport: false, footer: false, copyright: false, stylesheet: false
        },
        actions: []
      },
      {
        countries: ['GB'],
        salesOrgs: ['GB49'],
        disable: {
          favIcon: false, pageTitle: false, logo: false, myText: false, myCompanyWebsite: false, contactUs: true, customerSuppport: false, footer: false, copyright: false, stylesheet: false
        },
        actions: []
      },
      {
        disable: {
          favIcon: false, pageTitle: false, logo: false, myText: false, myCompanyWebsite: false, contactUs: false, customerSuppport: false, footer: false, copyright: false, stylesheet: false
        }
      }
    ])

    this.$store.dispatch('getUser');
    const resPhoneNavigation = await GetData('/api/v1/navigation/left');
    if (resPhoneNavigation.status === 200) this.navItems = resPhoneNavigation.data;
    const resContactUsUrl = await GetData('/api/v1/user/contactus');
    if (resContactUsUrl.status === 200) this.contactUsUrl = resContactUsUrl.data;
    const resFacebookUrl = await GetData('/api/v1/user/facebook');
    if (resFacebookUrl.status === 200) this.facebookUrl = resFacebookUrl.data;
    const resTwitterUrl = await GetData('/api/v1/user/twitter');
    if (resTwitterUrl.status === 200) this.twitterUrl = resTwitterUrl.data;
    const resYoutubeUrl = await GetData('/api/v1/user/youtube');
    if (resYoutubeUrl.status === 200) this.youtubeUrl = resYoutubeUrl.data;
    const resLinkedinUrl = await GetData('/api/v1/user/linkedin');
    if (resLinkedinUrl.status === 200) this.linkedinUrl = resLinkedinUrl.data;
    const resLegalnoticeUrl = await GetData('/api/v1/user/legalnotice');
    if (resLegalnoticeUrl.status === 200) this.legalnoticeUrl = resLegalnoticeUrl.data;
    const resPrivacypolicyUrl = await GetData('/api/v1/user/privacypolicy');
    if (resPrivacypolicyUrl.status === 200) this.privacypolicyUrl = resPrivacypolicyUrl.data;
    const resCookieNoticeUrl = await GetData('/api/v1/user/cookie-notice');
    if (resCookieNoticeUrl.status === 200) this.cookieNoticeUrl = resCookieNoticeUrl.data;
    const resCustomerSupportUrl = await GetData('/api/v1/user/support');
    if (resCustomerSupportUrl.status === 200) this.customerSupportUrl = resCustomerSupportUrl.data;
    this.$store.dispatch('getShipTos')
    this.$store.dispatch('getApplications')
    this.$store.dispatch('getRevalidationStatus')
  },
  updated() {
    const country = window.apci.getCookieByName('Country')
    const salesOrg = window.apci.getCookieByName('SalesOrg')
    const env = window.apci.getEnvironmentPrefix()
    const localeId = window.apci.getCookieByName('LocaleId')

    const options = window.apci.determineReplacementOptions(
      [
        {
          countries: ['GB'],
          salesOrgs: ['GB46'],
          actions: [
            { action: 'remove', selector: '#ap-top-bar > div.left > a#osvc_reg_contactus' },
            { action: 'replace', selector: '#ap-top-bar > div.left > a', property: 'href', value: 'https://portal.airproducts.com/' },
            { action: 'replace', selector: '#ap-top-bar > div.left > a#osvc_reg_customerSupport', property: 'href', value: 'https://gasdirect.co.uk/customer-support' },
            { action: 'remove', selector: '#need-help' }
          ]
        },
        {
          countries: ['GB'],
          salesOrgs: ['GB47'],
          actions: [
            { action: 'remove', selector: '#ap-top-bar > div.left > a#osvc_reg_contactus' },
            { action: 'replace', selector: '#ap-top-bar > div.left > a', property: 'href', value: 'https://portal.airproducts.com/' },
            { action: 'replace', selector: '#ap-top-bar > div.left > a#osvc_reg_customerSupport', property: 'href', value: 'https://gasdirect.co.uk/customer-support' },
            { action: 'remove', selector: '#need-help' }
          ]
        },
        {
          countries: ['GB'],
          salesOrgs: ['GB49'],
          actions: [
            { action: 'remove', selector: '#ap-top-bar > div.left > a#osvc_reg_contactus' },
            { action: 'replace', selector: '#ap-top-bar > div.left > a', property: 'href', value: 'https://portal.airproducts.com/' },
            { action: 'replace', selector: '#ap-top-bar > div.left > a#osvc_reg_customerSupport', property: 'href', value: 'https://gasdirect.co.uk/customer-support' },
            { action: 'remove', selector: '#need-help' }
          ]
        }
      ],
      country,
      salesOrg
    )

    options.selectorOverrides = options.selectorOverrides || {}
    window.apci.performReplacements(options)
    window.apci.changeFooter(country, salesOrg, options)
    window.apci.changeContactUs(country, env, options, localeId)
    window.apci.changeCustomerSupport(country, env, options, localeId, salesOrg)
  },
  created() {
    const containerId = window.__env.gtmContainerId
    this.enableGTM(window, document, 'script', 'dataLayer', containerId)
  },
  methods: {
    enableGTM(w, d, s, l, i) {
      w[l] = w[l] || []
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
      const f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l !== 'dataLayer' ? '&l=' + l : ''
      j.async = true
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
      f.parentNode.insertBefore(j, f)
    }
  }
}
